<template>
  <div class="detail">
    <a-tabs v-model:activeKey="listQuery.tabStatus" type="editable-card" :hideAdd="true">
      <a-tab-pane
        v-for="item in data.tabList"
        :key="item.id"
        :activeKey="item.id"
        :tab="item.title"
        :closable="false"
      />
    </a-tabs>
    <div class="checkImg" v-if="!listQuery.tabStatus">
      <div class="z-fixed topClass">
        <div class="leftText boldTextClass">检查单报告</div>
        <div class="rightText">
          <span class="rTxt">检查单ID：{{ checklistId }}</span>
          <span class="rTxt">
            关联随访计划：{{
              data.checkForm.adPlanId && data.checkForm.adPlanId > 0
                ? data.checkForm.adPlanId
                : '--'
            }}
          </span>
          <span class="rTxt">推送时间：{{ data.checkForm.sendTime }}</span>
          <span class="rTxt">上传时间：{{ data.checkForm.uploadTime || '--' }}</span>
        </div>
      </div>
      <div>
        <div v-if="data.imgList.length > 0">
          <ImageWithName :fileList="data.imgList" />
        </div>
        <div v-else>
          <div class="z-fixed-c">
            <auth-img class="empty-img" src="@/assets/img/empty.png" />
          </div>
          <div class="z-fixed-c empty-txt">暂无数据</div>
        </div>
      </div>
    </div>
    <div v-else class="checkForm">
      <a-form layout="vertical" v-if="data.checkList.length > 0">
        <div class="rightText">编辑时间：{{ data.checkForm.editTime }}</div>
        <div
          v-for="(pane, index) in data.checkList"
          :key="index"
          class="checkList"
          :style="{ borderBottom: data.checkList.length > 1 ? '' : '0' }"
        >
          <div class="boldTextClass" style="margin-bottom: 16px">
            {{ pane.checklistName }}
          </div>
          <div class="formGrid">
            <div class="fromText" v-for="(formItem, itemIndex) in pane.items" :key="itemIndex">
              <a-form-item :label="formItem.itemName">
                <!-- <a-input-number
                  :placeholder="formItem.valueDetailUnit ? '' : '无'"
                  v-if="[1, 2].includes(formItem.itemType)"
                  v-model:value="formItem.valueDetailUnit"
                  class="formClass"
                  disabled
                /> -->
                <a-date-picker
                  v-if="formItem.itemType === 3"
                  valueFormat="YYYY-MM-DD"
                  v-model:value="formItem.valueDetailUnit"
                  class="formClass"
                  disabled
                  :placeholder="formItem.valueDetailUnit ? '' : '无'"
                />
                <!-- <a-input
                  v-if="[1, 2, 4].includes(formItem.itemType)"
                  v-model:value="formItem.valueDetailUnit"
                  class="formClass"
                  :placeholder="formItem.valueDetailUnit ? '' : '无'"
                  disabled
                /> -->
                <a-textarea
                  v-if="[1, 2, 4].includes(formItem.itemType)"
                  v-model:value="formItem.valueDetailUnit"
                  class="formClass"
                  :placeholder="formItem.valueDetailUnit ? '' : '无'"
                  :auto-size="data.autosize"
                  disabled
                />
                <a-textarea
                  v-if="[5].includes(formItem.itemType)"
                  v-model:value="formItem.valueDetailUnit"
                  class="formClass-textarea"
                  :auto-size="data.autosize"
                  disabled
                />
                <a-radio-group
                  v-if="[6].includes(formItem.itemType)"
                  v-model:value="formItem.valueSort"
                  disabled
                >
                  <a-radio
                    v-for="(radioItem, radioIndex) in formItem.options"
                    :key="radioIndex + 1"
                    :value="radioIndex + 1"
                  >
                    {{ radioItem.optionContent }}
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
        </div>
      </a-form>
      <div v-else>
        <div class="z-fixed-c">
          <auth-img class="empty-img" src="@/assets/img/empty.png" />
        </div>
        <div class="z-fixed-c empty-txt">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, defineProps, onMounted } from 'vue'
import { checklistItemInit } from '@/api/HealthRecord/index.js'
import ImageWithName from '@/components/ImageWithName'
const props = defineProps({
  checklistId: {
    type: String,
    value: ''
  },
  // 当前弹窗的显示状态
  visible: {
    type: Boolean,
    value: false
  },
  // 从服务记录查看检查单快照
  details: {
    type: Object,
    default: () => {}
  },
  mode: {
    type: String,
    default: ''
  }
})
const data = reactive({
  fallbackImg: require('@/assets/img/img-err.png'),
  // 轮播图数据
  autosize: {
    minRows: 1,
    maxRows: 6
  },
  imgList: [],
  tabList: [
    {
      id: 0,
      title: '检查单图片'
    },
    {
      id: 1,
      title: '检查单表单'
    }
  ],
  defaultQuery: {
    tabStatus: 0
  },
  checkList: [],
  checkForm: {}
})
const listQuery = reactive({
  ...data.defaultQuery
})
const getList = checklistId => {
  checklistItemInit({ checklistId: checklistId }).then(res => {
    if (res && res[0]) {
      handleRes(res[0])
    }
  })
}
const handleRes = res => {
  data.checkForm = res
  data.imgList = res.urlFileList
  // 处理数据
  detailInit(res.questions).then(detailRes => {
    if (detailRes.length > 0) {
      data.checkList = detailRes
    } else {
      data.checkList = []
    }
  })
}
// 去除数组对象为空的数据
const trimSpace = array => {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === ' ' || array[i] == null || typeof array[i] + '' === 'undefined') {
      array.splice(i, 1)
      i = i - 1
    }
  }
  return array
}
// 初始化tab标签数据，初始化详情数据
const detailInit = questions => {
  return new Promise(resolve => {
    const initTabs = reactive([])
    questions.map(q => {
      let isHaveDetil = reactive({})
      if (q.items.length > 0) {
        //找出items里valueDetail有值的
        isHaveDetil = trimSpace(q.items.map(item => item.valueDetail))
        if (isHaveDetil.length > 0) {
          initTabs.push(q)
        }
      }
    })
    resolve(initTabs)
  })
}
onMounted(() => {
  if (props.mode === 'snapshot') {
    handleRes(props.details)
  } else {
    getList(props.checklistId)
  }
})
watch(
  () => [listQuery.tabStatus, props.checklistId, props.visible],
  (newValues, oldValues) => {
    // if (newValues[1] !== oldValues[1]) {
    //   getList(newValues[1])
    // }
    //如果弹窗不显示就把tab的值归0（初始化tab的值）
    if (!newValues[2]) {
      listQuery.tabStatus = 0
    } else {
      if (newValues[2] !== oldValues[2]) {
        if (props.mode === 'snapshot') {
          handleRes(props.details)
        } else {
          getList(newValues[1])
        }
      }
    }
  }
  // { immediate: true }
)
</script>

<style scoped lang="scss">
.boldTextClass {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
}
.detail {
  position: relative;
  height: 100%;
  // ::v-deep(.ant-radio-disabled .ant-radio-inner::after) {
  //   background-color: #1890ff;
  // }
  ::v-deep(.ant-image) {
    width: 140px;
    height: 120px;
    overflow: hidden;
  }
  ::v-deep(.ant-image-img) {
    width: 140px;
    height: 120px;
    object-fit: cover;
  }
  .empty-img {
    margin-top: 80px;
  }
  .empty-txt {
    font-size: 14px;
    color: #999999;
    margin-top: 17px;
  }
  ::v-deep(.ant-radio-disabled + span) {
    color: #333333;
    font-weight: bold;
  }
  ::v-deep(.ant-input-number-disabled .ant-input-number-input) {
    color: #333333;
    // background-color: #f5f5f5a3;
    background: #ffffff;
    font-weight: bold;
  }
  ::v-deep(.ant-input-number-disabled) {
    color: #333333;
    // background-color: #f5f5f5a3;
    border: 1px solid rgba(217, 217, 217, 0.3);
    font-weight: bold;
  }

  ::v-deep(.ant-input[disabled]) {
    color: #333333;
    font-size: 14px;
    background: #ffffff;
    // background-color: #f5f5f5a3;
    // border: 1px solid #d9d9d9;
    border: 1px solid rgba(217, 217, 217, 0.3);
    font-weight: bold;
  }
  ::v-deep(.ant-form-item-label > label) {
    color: #999999;
    font-size: 12px;
  }
  ::v-deep(.ant-form-item) {
    margin-bottom: 20px;
  }
  .formClass {
    width: 250px;
  }
  .formClass-textarea {
    width: 100%;
  }
  .checkForm {
    height: calc(100vh - 400px);
    overflow-y: scroll;
    position: relative;
    .rightText {
      position: absolute;
      right: 0;
      font-size: 12px;
      color: #999999;
      text-align: right;
    }
    .checkList {
      // padding: 23.5px 0;
      border-bottom: 1px solid #e8e8e8;
      margin-bottom: 23.5px;
    }
    .formGrid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 0 10px;
      .fromText {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 12px;
        color: #666666;
        // margin-top: 16px;
        span {
          color: #333333;
          margin-left: 5px;
        }
      }
    }
  }

  .checkImg {
    height: calc(100vh - 400px);
    overflow-y: scroll;
    .gridImgs {
      display: grid;
      grid-template-columns: repeat(6, 140px);
      grid-gap: 20px 32px;
    }
    .imgClass {
      height: 120px;
      background: rgba(0, 0, 0, 0.1);
    }
    .topClass {
      margin-bottom: 24px;
      .leftText {
        width: 10%;
      }
      .rightText {
        width: 90%;
        float: right;
        text-align: right;
        .rTxt {
          margin-left: 40px;
          font-size: 12px;
          color: #999999;
        }
      }
    }
    .span {
      font-family: PingFangSC-Medium;
      font-weight: bold;
      font-size: 14px;
      color: #999999;
      margin-left: 40px;
      text-align: right;
    }
  }
}
</style>
